var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPontisGlobalLogoHorizontalReversed(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "b",
    xmlns: "http://www.w3.org/2000/svg",
    width: 207,
    height: 48.25,
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 207 48.25",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".e{fill:url(#d);}.f{fill:#fff;}"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "d",
    x1: 50.58,
    y1: 7.53,
    x2: 16.66,
    y2: 37.56,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f47820"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f15e24"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "c"
  }, /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M73.37,30.96V5.34h11.98c5.57,0,8.6,3.76,8.6,8.26s-3.07,8.18-8.6,8.18h-6.53v9.18h-5.45ZM84.62,10.03h-5.8v7.07h5.8c2.15,0,3.76-1.38,3.76-3.53s-1.61-3.53-3.76-3.53Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M109.48,4.92c7.76,0,13.41,5.53,13.41,13.25s-5.65,13.25-13.41,13.25-13.37-5.53-13.37-13.25,5.65-13.25,13.37-13.25ZM109.48,9.76c-4.73,0-7.76,3.61-7.76,8.41s3.03,8.41,7.76,8.41,7.8-3.65,7.8-8.41-3.07-8.41-7.8-8.41Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M144.41,30.96l-12.22-17.21v17.21h-5.45V5.34h5.61l11.87,16.59V5.34h5.45v25.62h-5.26Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M160.66,30.96V10.14h-7.49v-4.8h20.44v4.8h-7.45v20.82h-5.49Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M177.11,30.96V5.34h5.45v25.62h-5.45Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M188.87,23.2c1.81,1.88,4.61,3.46,8.14,3.46,3,0,4.46-1.42,4.46-2.88,0-1.92-2.23-2.57-5.19-3.27-4.19-.96-9.56-2.11-9.56-7.84,0-4.26,3.69-7.72,9.72-7.72,4.07,0,7.45,1.23,9.99,3.57l-3.03,3.99c-2.07-1.92-4.84-2.8-7.34-2.8s-3.77,1.08-3.77,2.61c0,1.73,2.15,2.27,5.11,2.96,4.23.96,9.6,2.23,9.6,7.91,0,4.69-3.34,8.22-10.26,8.22-4.92,0-8.45-1.65-10.87-4.07l3-4.15Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M141.43,36.85c2.28,0,3.71,1.11,4.55,2.41l-1.95,1.06c-.51-.78-1.45-1.39-2.61-1.39-2,0-3.45,1.53-3.45,3.61s1.45,3.61,3.45,3.61c1.01,0,1.9-.41,2.38-.84v-1.34h-2.94v-2.01h5.25v4.21c-1.12,1.25-2.69,2.08-4.69,2.08-3.22,0-5.86-2.24-5.86-5.71s2.64-5.69,5.86-5.69Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M147.99,48.03v-11h2.34v8.94h4.65v2.06h-7Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M161.39,36.85c3.33,0,5.76,2.38,5.76,5.69s-2.43,5.69-5.76,5.69-5.74-2.37-5.74-5.69,2.43-5.69,5.74-5.69ZM161.39,38.93c-2.03,0-3.33,1.55-3.33,3.61s1.3,3.61,3.33,3.61,3.35-1.57,3.35-3.61-1.32-3.61-3.35-3.61Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M168.81,48.03v-11h5.79c2.1,0,3.17,1.34,3.17,2.8,0,1.39-.86,2.31-1.9,2.52,1.17.18,2.11,1.32,2.11,2.71,0,1.65-1.11,2.97-3.2,2.97h-5.97ZM171.15,41.45h2.94c.79,0,1.29-.51,1.29-1.22s-.49-1.21-1.29-1.21h-2.94v2.43ZM171.15,46.04h3.02c.89,0,1.42-.51,1.42-1.3,0-.69-.49-1.29-1.42-1.29h-3.02v2.59Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M187.46,48.03l-.69-1.9h-4.92l-.69,1.9h-2.57l4.26-11h2.94l4.24,11h-2.56ZM184.3,39.06l-1.83,5.05h3.65l-1.81-5.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M191.04,48.03v-11h2.34v8.94h4.65v2.06h-7Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M200.7,48.03v-2.39h-.85v-.36h2.12v.36h-.85v2.39h-.41Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M204.76,48.03v-2.19l-.89,2.19h-.17l-.89-2.19v2.19h-.41v-2.75h.59l.8,1.98.8-1.98h.59v2.75h-.41Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M53.54,12.52c-3.01-5.84-8.47-10.36-15.37-11.93C26.5-2.08,14.88,4.62,11.17,15.74c13.07-5.03,27.69-6.42,42.37-3.23ZM59.02,27.53c3.46,3.79,4.98,7.18,3.82,9.45-1.39,2.72-6.34,3.29-13.1,1.99,2.77-2.91,4.82-6.57,5.78-10.77,1.08-4.71.61-9.41-1.05-13.59-9.32,3.3-17.78,8.69-24.72,15.73,4.24,3.02,8.96,5.44,8.96,5.44,0,0-5.06-1.81-9.93-4.44C12.61,23.11,1.63,12.3,4.23,7.18c1.15-2.27,4.79-3.04,9.89-2.48C6.94,3.25,1.76,3.72.37,6.46c-2.67,5.25,9.58,16.84,27.4,25.98-2.74,3.04-5.22,6.35-7.36,9.91,2.23,1.47,4.74,2.58,7.5,3.21,7.43,1.7,14.84-.41,20.2-5.03,9.14,2.46,15.97,2.36,17.6-.85,1.39-2.74-1.28-7.2-6.68-12.15Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPontisGlobalLogoHorizontalReversed);
export default __webpack_public_path__ + "static/media/Pontis Global Logo - Horizontal Reversed.f952278f5926f8ba92893ecbd3eb6b72.svg";
export { ForwardRef as ReactComponent };